import Tooltip from 'rc-tooltip';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { makeid, Pagination } from '../core/index';
import { BookingData, CommonCommunicationData, SecurityData } from '../shared/index';
import { CoreComponentAjaxUtils, getAcountData, getAjaxhelper, isNull, momentWrapper } from '../utils/index';
import { MyHotelBookingData } from './MyHotelBookingData'; 

export interface MyBookingProps extends BaseComponentProps {
	lang: string;
	user: SecurityData.ApplicationUser;
	user_login: boolean;
}
export interface MyBookingState extends BaseComponentState {
	bookingDatas: BookingData.BookingHeaderSimple[];
	count: number;
	requesting: boolean;
	customer: BookingData.Customer | any;
	page: number;
	total: number;
}

export class MyBooking extends BaseComponent<MyBookingProps, MyBookingState> {

	constructor(props: MyBookingProps) {
		super(props);
		this.state = {
			bookingDatas: [],
			count: 15,
			requesting: true,
			customer: null,
			page: 0,
			total: 0
		};
	}

	componentWillMount() {
		this.getAccount();
	}

	getAccount: () => any = () => {
		if (!isNull(this.props.user)) {
			getAcountData(this.props.user.userId!).then((d: any) => { 
				let custId = d.id;
				this.setState({ customer: d }, () => { this.getBookingData(custId); });
			}).catch(exc => {
				console.log(exc);
			});
		}

	}

	componentDidUpdate(prevProps: MyBookingProps, prevState: MyBookingState) {
		if (prevProps.user !== this.props.user) {
			this.getAccount();
		}
	}

	getBookingData: (custId: number) => any = (custId: number) => {
		let incModel: CommonCommunicationData.IncludeModelParam[] = [{
			modelName: 'Hotel'
		}, { 
			modelName: 'BookingCheckOut'}];
		new CoreComponentAjaxUtils(getAjaxhelper()).getPagedDataWithPromise({
			modelName: 'BookingHeader',
			pageSize: this.state.count,
			page: this.state.page,
			orders: [['createdAt', 'desc']],
			where: {
				statusCode: { $in: ['SUCCESS', 'CANCELED'] }
			},
			eraseAuditTrail: true,
			includeModels: incModel
		}).then(
			d => { 
				this.setStateHelper(
					st => {
						let datas: BookingData.BookingHeader[] = d.rows as any;
						if (!isNull(datas)) {
							/*
							for (let b of datas) {
								// let resData: any = JSON.parse(b.respRawData!);
								// b.checkinDate = resData.hotel.checkIn;
								// b.checkoutDate = resData.hotel.checkOut;
							}
							*/
							st.bookingDatas = datas;
							st.total = d.count!;
						}

						st.requesting = false;

					}
				);
			}).catch((exc) => { console.error('error: ', exc); });
	}

	render() {
		if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
		let isiBody = [];
		if (this.state.requesting === false && !isNull(this.state.bookingDatas)) {
			for (let a of this.state.bookingDatas) {
				let cal = <p><i className="ti-calendar" /> {momentWrapper(a.checkinDate).format('MMMM Do YYYY')} - {momentWrapper(a.checkoutDate).format('MMMM Do YYYY')}</p>;
				let holderData = [];
				if (a.BookingCheckOut) {
					let holder = JSON.parse(a.BookingCheckOut.holder!);
					holderData.push(holder.name + ' ' + holder.surname);
					holderData.push(<br/>);
					holderData.push(holder.phone);
					holderData.push(<br/>);
					holderData.push(holder.email);
					 
				}
				isiBody.push(
					<tr key={makeid()}>
						<td>
							<MyHotelBookingData id={a.Hotel!.code} hotel={a.Hotel as any} lang={this.props.lang} cal={cal} />
						</td>
						<td>{a.statusCode}</td>
						<td> {holderData}  
						</td> 
						<td>
							<Tooltip
								placement='bottom'
								overlay={<div style={{ minWidth: 50 }}> Show your Booking Voucher </div>}
							>
								<Link to={`/voucher-confirmed?id=${a.localReffNo}`} target="_blank" style={{ fontSize: 24 }}><i className="ti-envelope" /></Link>
							</Tooltip>
						</td>
					</tr>
				);
			}
		}
		if (isiBody.length === 0) {
			isiBody.push(
				<tr key={makeid()}>
					<td>
						No booking data found 
					</td>
					<td/>  
					<td/> 
					<td/>  
					<td/> 
				</tr>
			);
		}

		return (
			<div style={{ minHeight: 500, marginBottom: 30 }}>
				<div style={{ minHeight: 500, backgroundColor: '#fff', borderRadius: 8, border: '1px #fafafa solid' }}>
					<table className="table ">
						<thead>
							<tr>
								<th>Hotel</th>
								<th>Status</th>
								<th>Customer</th>
								<th>View</th>
							</tr>
						</thead>
						<tbody>
							{isiBody}
						</tbody>
					</table>
					<Pagination pageSize={this.state.count} onChangePage={this.onChangePage} page={this.state.page} totalCount={this.state.total} />
				</div>
			</div>

		);
	}

	onChangePage: (page: number) => any = (page: number) => {
		this.setStateHelper(st => st.page = page, () => {
			this.getAccount();
		});
	}
}



// WEBPACK FOOTER //
// ./src/my-account/MyBooking.tsx